import { createFileRoute } from '@tanstack/react-router';
import { adminAudit } from '@/api/resources';
import { warm } from '@/api/loaders';
import { requireCapability } from '@/lib/route-guards';
import { useSetViewShim } from '@/lib/use-set-view';
import { AuditView } from '@/screens/admin-audit';

export const Route = createFileRoute('/admin/audit')({
  // The API's `require_capability` admits any level above `none`, hence `own`.
  beforeLoad: requireCapability('audit_view', 'own'),
  // The screen's own default window and page size. Warming a different pair
  // would fill a slot nothing reads and paint the empty state anyway, which is
  // the one way a loader fails while looking correct.
  loader: ({ context }) => warm(context.queryClient, adminAudit({ window: '30d', limit: 200 })),
  component: Page,
});

function Page() {
  const setView = useSetViewShim();
  return <AuditView setView={setView} />;
}
